export default class centroCosto{
	constructor($scope,
				$routeParams,
				method,
				centroCostosService,
				$location,
                $uibModal,
                toastr,
                proyectosService
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(centroCostosService);
			break;
			case 'new':
				this.create(centroCostosService,proyectosService);
			break;
			case 'view':
				this.view($routeParams,
                    centroCostosService,proyectosService);
			break;
		}
	}

	list(centroCostosService){
        let self = this.scope;

        centroCostosService.getAll().then((resp, err) => {
            self.centrosDeCostos = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.centrosDeCostos.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            console.log(pageNumber);
            return pageNumber;
        };
        self.eliminar = this.eliminar.bind(this, centroCostosService);
	}

	create(centroCostosService, proyectosService){

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.proyectos = resp.data.message;
            }
        });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                centroCostosService.save(this.scope.centro_costo).then((resp) => {
                    this.toastr.success('Centro de costo creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/centro_costo');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error al crear el centro de costo!','Error', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         centroCostosService, proyectosService){

		this.scope.aux = {};
        centroCostosService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.centro_costo = resp.data.message;
		}).catch((er) => {
			console.log(er);
        });
        
        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.proyectos = resp.data.message;
            }
        });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                centroCostosService.update(this.scope.centro_costo).then((resp) => {
                    this.toastr.success('Centro de costo modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/centro_costo');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el centro de costo!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,centroCosto, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Centro de costo</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el centro de costo: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = centroCosto.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                console.log(indexObject);
                self.inAction = true;
                service.delete({_id: centroCosto._id}).then((resp) => {
                    self.scope.centrosDeCostos.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Centro de costo eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error( 'Error al eliminar el centro de costo!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/centro_costo/centro_costo.js